import React from "react";
import { Box, FormControl, FormLabel, Text } from "@chakra-ui/react";
import { Select as ChakraReactSelect } from "chakra-react-select";

type Option = { label: string; value: string; meaning?: string };

const BU_KEY_OPTIONS: Option[] = [
  { value: "0", label: "0 - Automatikkonto – Steuerlogik wird vollständig über das Sachkonto gesteuert", meaning: "Automatikkonto – Steuerlogik wird vollständig über das Sachkonto gesteuert" },
  { value: "1", label: "1 - Steuerfreie Umsätze mit Vorsteuerabzug (§4 Nr. 2–7 UStG)", meaning: "Steuerfreie Umsätze mit Vorsteuerabzug (§4 Nr. 2–7 UStG)" },
  { value: "2", label: "2 - Umsatzsteuer 7% (ermäßigt)", meaning: "Umsatzsteuer 7% (ermäßigt)" },
  { value: "3", label: "3 - Umsatzsteuer 19% (Regelsatz)", meaning: "Umsatzsteuer 19% (Regelsatz)" },
  { value: "5", label: "5 - Innergemeinschaftlicher Erwerb 19%", meaning: "Innergemeinschaftlicher Erwerb 19%" },
  { value: "6", label: "6 - Innergemeinschaftlicher Erwerb 7%", meaning: "Innergemeinschaftlicher Erwerb 7%" },
  { value: "8", label: "8 - Vorsteuer 7%", meaning: "Vorsteuer 7%" },
  { value: "9", label: "9 - Vorsteuer 19%", meaning: "Vorsteuer 19%" },
  { value: "10", label: "10 - Nicht steuerbare innergemeinschaftliche Lieferung", meaning: "Nicht steuerbare innergemeinschaftliche Lieferung" },
  { value: "11", label: "11 - Steuerfreie innergemeinschaftliche Lieferung mit USt-IdNr.", meaning: "Steuerfreie innergemeinschaftliche Lieferung mit USt-IdNr." },
  { value: "95", label: "95 - Reverse-Charge-Verfahren (§13b UStG)", meaning: "Reverse-Charge-Verfahren (§13b UStG)" },
  { value: "96", label: "96 - Aufzuteilende Vorsteuer (allgemein)", meaning: "Aufzuteilende Vorsteuer (allgemein)" },
  { value: "97", label: "97 - Aufzuteilende Vorsteuer 19%", meaning: "Aufzuteilende Vorsteuer 19%" },
  { value: "98", label: "98 - Aufzuteilende Vorsteuer 7%", meaning: "Aufzuteilende Vorsteuer 7%" },
];

function toOption(value?: string): Option | null {
  const v = (value || "").trim();
  if (!v) return null;
  return BU_KEY_OPTIONS.find((o) => o.value === v) || { value: v, label: v };
}

export function BuKeySelect({
  value,
  onChange,
  isDisabled,
  label,
  placeholder,
  hint,
}: {
  value?: string;
  onChange: (next: string) => void;
  isDisabled?: boolean;
  label?: React.ReactNode;
  placeholder?: string;
  hint?: React.ReactNode;
}) {
  return (
    <FormControl>
      {label ? (
        <FormLabel fontSize="sm" display="flex" alignItems="center" gap={2}>
          {label}
        </FormLabel>
      ) : null}
      <ChakraReactSelect
        placeholder={placeholder || "Select BU key"}
        value={toOption(value)}
        isDisabled={!!isDisabled}
        onChange={(selectedOption) => onChange((selectedOption as any)?.value || "")}
        options={BU_KEY_OPTIONS}
        isSearchable={true}
        isClearable={true}
        size="md"
        menuPortalTarget={typeof window !== "undefined" ? document.body : null}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 2000 }),
        }}
      />
      {hint ? (
        <Box mt={1}>
          <Text fontSize="xs" color="gray.500">
            {hint}
          </Text>
        </Box>
      ) : null}
    </FormControl>
  );
}



